export function columnPositionError(
  value: unknown,
  total: number
): string | undefined {
  const position = Number(value);
  return !String(value ?? "").trim() ||
    !Number.isInteger(position) ||
    position < 1 ||
    position > total
    ? `Enter a position from 1 to ${total}.`
    : undefined;
}

export function moveColumns(
  names: string[],
  selected: string[],
  position: number
): string[] {
  const selection = new Set(selected);
  const moving = names.filter((name) => selection.has(name));
  const remaining = names.filter((name) => !selection.has(name));
  if (!moving.length || columnPositionError(position, remaining.length + 1))
    return names;
  remaining.splice(position - 1, 0, ...moving);
  return remaining;
}
